(function () {
  'use strict';

  // Vérification de la configuration
  if (!window.TalikaConfig) {
    console.error('❌ TalikaConfig non trouvé');
    window.TalikaConfig = { 
      products: {}, 
      money_format: '€ {amount}', 
      currency: 'EUR' 
    };
  }

  if (!window.TalikaConfig.products || typeof window.TalikaConfig.products !== 'object') {
    window.TalikaConfig.products = {};
  }

  const { products, money_format, currency = 'EUR' } = window.TalikaConfig;
  const HIDDEN_PRODUCTS = [];

  const filterHiddenProducts = products => products.filter(product => !HIDDEN_PRODUCTS.includes(product));

  // Suivi Klaviyo — réinstauré le 24/07/2026 (le tracking avait disparu de l'asset,
  // dernier événement reçu le 24/10/2025 : plus rien n'était mesuré depuis).
  // Le payload reprend volontairement le schéma des événements historiques pour
  // rester comparable dans Klaviyo.
  function trackKlaviyo(eventName, properties) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, Object.assign({
        source: 'talika-diagnostic-tool',
        page_url: window.location.href,
      }, properties)]);
    } catch (error) {
      // Le suivi ne doit jamais casser le parcours
      console.warn('Suivi Klaviyo indisponible:', error);
    }
  }

  // Propriétés de profil Klaviyo (zero-party data) : posées sur le profil
  // anonyme, fusionnées automatiquement dès que la cliente laisse son email.
  // Servent au SAV (fiche profil), aux segments et à la personnalisation email.
  function identifyKlaviyo(properties) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', properties]);
    } catch (error) {
      console.warn('Identify Klaviyo indisponible:', error);
    }
  }

  // Valeur d'un ensemble de produits (clés internes) en euros
  function routineValue(productKeys) {
    return productKeys.reduce((total, productKey) => {
      const product = products[productMapping[productKey]];
      return total + (product && typeof product.price === 'number' ? product.price : 0);
    }, 0) / 100;
  }

  // Préoccupations / souhaits adressés par chaque produit — sert au tag « 🎯 »
  // du CTA maître quand la cliente a coché la préoccupation correspondante
  const PRODUCT_TARGETS = {
    serumAntiAge: ['wrinkles'], maskAntiAge: ['wrinkles'],
    dayCremeAntiAgeDry: ['wrinkles'], nightCremeAntiAgeDry: ['wrinkles'],
    dayCremeAntiAgeOily: ['wrinkles'], nightCremeAntiAgeOily: ['wrinkles'],
    serumPurifiant: ['imperfections'], maskPurifying: ['imperfections'],
    bubbleMask: ['imperfections'], freeSkin: ['imperfections'], gelCremePurifiant: ['imperfections'],
    serumHydra: ['dehydration'], maskHydrating: ['dehydration'],
    maskSoothing: ['sensitivity'],
    maskBrightening: ['spots'], timeControl: ['spots'],
    lipocilsPlatinium: ['fuller'], lipocilsExpert: ['pigmented', 'curled'],
    lipocils: ['longer', 'resistant'],
  };
  const TARGET_LABELS = {
    wrinkles: 'rides', imperfections: 'imperfections', dehydration: 'hydratation',
    sensitivity: 'apaisement', spots: 'anti-taches',
    fuller: 'cils plus fournis', pigmented: 'pigmentation', curled: 'courbure',
    longer: 'longueur', resistant: 'résistance',
  };

  // Offre routine — reflète le code Shopify DIAG20 (−20 € dès 100 €, actif sans
  // date de fin). Si le code change côté Shopify, mettre à jour ici.
  const ROUTINE_OFFER = { code: 'DIAG20', amountCents: 2000, thresholdCents: 10000 };

  function routineValueCents(productKeys) {
    return productKeys.reduce((total, productKey) => {
      const product = products[productMapping[productKey]];
      return total + (product && typeof product.price === 'number' ? product.price : 0);
    }, 0);
  }

  function formatEuros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // ✅ Nouvelle fonction: Sauvegarder directement dans Shopify customer metadata
  async function saveDiagnosticToShopifyCustomer(answers, recommendations) {
    try {
      // Préparer les métadonnées du diagnostic
      const diagnosticData = {
        diagnosis_age: answers.age || '',
        diagnosis_skin_type: answers.skinType || '',
        diagnosis_concerns: Array.isArray(answers.concerns) ? answers.concerns.join(', ') : '',
        diagnosis_morning_routine: recommendations.morning.join(', ') || '',
        diagnosis_evening_routine: recommendations.evening.join(', ') || '',
        diagnosis_weekly_routine: recommendations.weekly.join(', ') || '',
        diagnosis_targeted_routine: recommendations.targeted.join(', ') || '',
        diagnosis_date: new Date().toISOString(),
        diagnosis_completed: true
      };

      console.log('✅ Données du diagnostic à sauvegarder:', diagnosticData);

      // Envoyer les métadonnées à une fonction serveur Shopify
      // Cette fonction devrait faire un fetch vers une route (cart page ou API personnalisée)
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: diagnosticData  // Shopify stocke les attributs du cart
        })
      });

      if (!response.ok) {
        console.warn('⚠️ Erreur lors de la sauvegarde des métadonnées');
        return false;
      }

      console.log('✅ Métadonnées du diagnostic sauvegardées dans Shopify');
      return true;

    } catch (error) {
      console.error('❌ Erreur saveDiagnosticToShopifyCustomer:', error);
      return false;
    }
  }

  // Ajout d'un produit au panier
  async function addToCartShopify(productHandle) {
    const productData = products[productHandle];
    if (!productData) throw new Error(`Produit ${productHandle} non trouvé`);
    if (!productData.variants?.[0]?.available) throw new Error('Produit non disponible');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: productData.variants[0].id,
        quantity: 1,
        properties: {
          '_diagnostic': 'talika-skincare',
          '_source': 'diagnostic-tool',
        },
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = `Erreur HTTP: ${response.status}`;
      try {
        const errorData = JSON.parse(errorText);
        errorMessage = errorData.message || errorData.description || errorMessage;
      } catch {}
      throw new Error(errorMessage);
    }

    if (response.headers.get('content-type')?.includes('application/json')) {
      await response.json();
    }

    // Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'add_to_cart', {
        currency,
        value: productData.variants[0].price / 100,
        items: [{
          item_id: productData.variants[0].id,
          item_name: productData.title,
          category: 'Skincare',
          quantity: 1,
          price: productData.variants[0].price / 100,
        }],
      });
    }

    return true;
  }

  // Gestion de l'ajout d'un produit individuel
  async function handleSingleProductAdd(productKey) {
    try {
      const handle = productMapping[productKey];
      if (!handle || !products[handle]) {
        throw new Error(`Produit ${productKey} non trouvé`);
      }

      showNotification('Ajout au panier en cours...', 'info');
      await addToCartShopify(handle);
      showNotification(`✅ ${products[handle].title} ajouté au panier !`, 'success');
      await updateCartCount();
    } catch (error) {
      console.error('Erreur ajout produit:', error);
      showNotification(`❌ ${error.message}`, 'error');
    }
  }

  // Affichage des notifications
  function showNotification(message, type = 'info') {
    const existing = document.querySelector('.diagnostic-notification');
    if (existing) {
      existing.classList.remove('show');
      setTimeout(() => existing.remove(), 300);
    }

    const notification = document.createElement('div');
    notification.className = `diagnostic-notification ${type}`;
    notification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 8px;">
        <span>${message}</span>
        <button style="background: none; border: none; color: inherit; font-size: 18px; cursor: pointer;">×</button>
      </div>
    `;
    notification.querySelector('button').addEventListener('click', () => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    });

    document.body.appendChild(notification);
    setTimeout(() => notification.classList.add('show'), 100);

    if (type !== 'error') {
      setTimeout(() => {
        if (notification.classList.contains('show')) {
          notification.classList.remove('show');
          setTimeout(() => notification.remove(), 400);
        }
      }, 4000);
    }
  }

  // Ajout d'une routine au panier
  async function addRoutineToCart(productKeys) {
    try {
      showNotification('Ajout de la routine en cours...', 'info');
      let successCount = 0, errorCount = 0;

      for (const productKey of productKeys) {
        try {
          if (await addToCartShopify(productMapping[productKey])) successCount++;
        } catch {
          errorCount++;
        }
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      const message = successCount > 0 && errorCount === 0
        ? `✅ ${successCount} produit(s) ajouté(s) au panier !`
        : successCount > 0
          ? `✅ ${successCount} produit(s) ajoutés, ${errorCount} échec(s)`
          : `❌ Impossible d'ajouter les produits`;
      showNotification(message, errorCount === 0 ? 'success' : errorCount > 0 && successCount > 0 ? 'warning' : 'error');

      if (successCount > 0) {
        trackKlaviyo('Diagnostic Routine Added to Cart', {
          products: productKeys.map(productKey => productMapping[productKey]).filter(Boolean),
          products_added: successCount,
          products_failed: errorCount,
          value: routineValue(productKeys),
        });
      }

      await updateCartCount();
    } catch (error) {
      console.error('Erreur ajout routine:', error);
      showNotification('Erreur lors de l\'ajout de la routine', 'error');
    }
  }

  // Ajout de la routine complète
  async function addCompleteRoutine(recommendations) {
    try {
      const uniqueProducts = [...new Set([
        ...recommendations.morning,
        ...recommendations.evening,
        ...recommendations.weekly,
        ...recommendations.targeted,
      ])];

      if (!uniqueProducts.length) {
        showNotification('❌ Aucun produit à ajouter', 'error');
        return;
      }

      showNotification(`Ajout de ${uniqueProducts.length} produits uniques...`, 'info');
      let successCount = 0, errorCount = 0;

      for (const productKey of uniqueProducts) {
        try {
          if (await addToCartShopify(productMapping[productKey])) successCount++;
        } catch {
          errorCount++;
        }
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      const message = successCount > 0 && errorCount === 0
        ? `✅ Routine complète ajoutée ! ${successCount} produits`
        : successCount > 0
          ? `✅ ${successCount} produits ajoutés, ${errorCount} échec(s)`
          : `❌ Impossible d'ajouter la routine`;
      showNotification(message, errorCount === 0 ? 'success' : errorCount > 0 && successCount > 0 ? 'warning' : 'error');

      await updateCartCount();
    } catch (error) {
      console.error('Erreur ajout routine complète:', error);
      showNotification('Erreur lors de l\'ajout de la routine complète', 'error');
    }
  }

  // Mise à jour du compteur panier
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      
      const cart = await response.json();
      if (!cart || cart.item_count === undefined) return;
      
      const selectors = [
        '.cart-count', '[data-cart-count]', '.cart-counter',
        '.cart-item-count', '#cart-count', '.header__cart-count', '.cart__count',
      ];

      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        if (!elements || elements.length === 0) return;
        
        elements.forEach(el => {
          if (!el || !el.parentNode) return;
          try {
            el.textContent = cart.item_count;
            el.style.transition = 'opacity 0.3s';
            el.style.opacity = '0';
            const elementRef = el;
            setTimeout(() => {
              if (elementRef && elementRef.parentNode) {
                elementRef.style.opacity = '1';
              }
            }, 100);
          } catch (e) {
            console.warn('Erreur update cart element:', e);
          }
        });
      });

      const mainCounter = document.querySelector('.cart-count, [data-cart-count]');
      if (mainCounter && mainCounter.parentNode) {
        mainCounter.style.transition = 'transform 0.2s';
        mainCounter.style.transform = 'scale(1.2)';
        setTimeout(() => {
          if (mainCounter && mainCounter.parentNode) {
            mainCounter.style.transform = 'scale(1)';
          }
        }, 200);
      }
    } catch (error) {
      console.warn('Impossible de mettre à jour le compteur panier:', error);
    }
  }

  // Mapping des produits
  const productMapping = {
    cleanser: 'mousse-nettoyante-hydratante-skintellige',
    eauMicellaire: 'eau-micellaire-hydratante',
    serumHydra: 'serum-hydra',
    serumAntiAge: 'serum-anti-age',
    serumPurifiant: 'serum-purifiant-skintelligence',
    glowtion: 'glowtion',
    gommage: 'gommage-doux-hydratant',
    dayCremeLight: 'creme-legere-hydra',
    dayCremeRich: 'creme-riche-hydra',
    dayCremeAntiAgeDry: 'creme-de-jour-regenerante-anti-age',
    nightCremeAntiAgeDry: 'creme-de-nuit-regenerante-anti-age',
    dayCremeAntiAgeOily: 'gel-creme-anti-age-jour',
    nightCremeAntiAgeOily: 'gel-creme-anti-age-nuit',
    gelCremePurifiant: 'gel-creme-purifiant',
    maskHydrating: 'bio-enzymes-mask-hydratant',
    maskAntiAge: 'bio-enzymes-mask-anti-age',
    maskPurifying: 'bio-enzymes-mask-purifiant',
    maskBrightening: 'bio-enzymes-mask-eclaircissant',
    maskSoothing: 'bio-enzymes-mask-cica-repair-apaisant',
    freeSkin: 'free-skin',
    bubbleMask: 'bubble-mask-bio-detox',
    timeControl: 'time-control-7-plus',
    lipocils: 'lipocils',
    lipocilsExpert: 'lipocils-expert-le-soin-culte',
    lipocilsPlatinium: 'lipocils-platinium',
    lipocilsDemaquillant: 'lipocils-demaquillant',
    lipocilsCrayon: 'lipocils-crayon',
    mascaraClassic: 'lipocils-mascara-1',
    mascaraXXLVolume: 'lipocils-mascara-xxl-volume',
    mascaraXXLExtension: 'lipocils-mascara-xxl-extension',
    mascaraExtensionWR: 'lipocils-mascara-xxl-extension-black-water-resistant',
  };

  // Récupération des données produit Shopify
  function getShopifyProduct(productKey) {
    const handle = productMapping[productKey];
    const shopifyProduct = products[handle];
    if (!shopifyProduct) return null;

    return {
      handle,
      name: shopifyProduct.title,
      price: shopifyProduct.price_formatted,
      image: shopifyProduct.featured_image || '',
      url: shopifyProduct.url,
      available: shopifyProduct.available,
      description: shopifyProduct.description || '',
      shopifyData: shopifyProduct,
    };
  }

  // Validation des produits
  function validateProducts() {
    const totalActiveProducts = Object.keys(productMapping).length - HIDDEN_PRODUCTS.length;
    let foundCount = 0, missingProducts = [], invalidVariants = [];

    for (const [key, handle] of Object.entries(productMapping)) {
      if (HIDDEN_PRODUCTS.includes(key)) continue;

      const product = products[handle];
      if (product) {
        foundCount++;
        if (!product.variants?.[0]?.id) {
          invalidVariants.push({ key, handle, reason: 'Variant invalide' });
        }
      } else {
        missingProducts.push({ key, handle });
      }
    }

    console.log(`📊 Produits: ${foundCount}/${totalActiveProducts} actifs trouvés`);
    if (missingProducts.length) {
      console.warn(`⚠️ Produits manquants: ${missingProducts.map(p => `${p.key}: ${p.handle}`).join(', ')}`);
    }
    if (invalidVariants.length) {
      console.warn(`⚠️ Variants invalides: ${invalidVariants.map(v => `${v.key}: ${v.reason}`).join(', ')}`);
    }
    if (HIDDEN_PRODUCTS.length) {
      console.log(`⏸️ Produits masqués: ${HIDDEN_PRODUCTS.join(', ')}`);
    }

    return foundCount > 0;
  }

  // Classe principale de l'application
  class DiagnosticApp {
    constructor(containerId) {
      this.container = document.getElementById(containerId);
      if (!this.container) {
        console.error(`Container ${containerId} non trouvé`);
        return;
      }

      this.currentStep = 0;
      this.answers = {};
      this.showResults = false;
      this.doneUniverses = [];
      this.savedRoutine = null;
      this.storageKey = 'talika-diagnostic-progress';
      this.universeQuestion = {
        id: 'universe',
        title: 'Quelle est votre priorité ?',
        type: 'radio',
        options: [
          { value: 'skin', label: 'Ma peau — une routine visage personnalisée', imageUrl: 'https://cdn.shopify.com/s/files/1/0513/4299/9748/files/Lipocils_ce_serum_culte_augmente_de_36_la_longueur_des_cils_et_de_50_leur_courbure.jpg?v=1708674070&crop=region&crop_left=1060&crop_top=0&crop_width=514&crop_height=514&width=300&height=300' },
          { value: 'lashes', label: 'Mon regard — des cils plus beaux', imageUrl: 'https://cdn.shopify.com/s/files/1/0513/4299/9748/files/newhp-mascara-macro.jpg?v=1784901782&crop=center&width=300&height=300' },
        ],
      };

      this.skinQuestions = [
        {
          id: 'age',
          title: 'Quel est votre âge ?',
          type: 'radio',
          options: [
            { value: 'under25', label: 'Moins de 25 ans' },
            { value: '25-35', label: '25-35 ans' },
            { value: '35-45', label: '35-45 ans' },
            { value: 'over45', label: 'Plus de 45 ans' },
          ],
        },
        {
          id: 'skinType',
          title: 'Comment décririez-vous votre type de peau ?',
          type: 'radio',
          options: [
            { value: 'dry', label: 'Sèche (tiraillements, inconfort)', icon: '🍂' },
            { value: 'oily', label: 'Grasse (brillances, pores dilatés)', icon: '🥑' },
            { value: 'combination', label: 'Mixte (zone T grasse, joues normales/sèches)', icon: '🌗' },
            { value: 'normal', label: 'Normale (équilibrée, confortable)', icon: '⚖️' },
          ],
        },
        {
          id: 'concerns',
          title: 'Quelles sont vos préoccupations principales ? (plusieurs réponses possibles)',
          type: 'checkbox',
          options: [
            { value: 'wrinkles', label: 'Rides et signes de vieillissement', icon: '⏳' },
            { value: 'imperfections', label: 'Imperfections, boutons, acné', icon: '🫧' },
            { value: 'dehydration', label: 'Déshydratation, manque d\'éclat', icon: '💧' },
            { value: 'sensitivity', label: 'Sensibilité, rougeurs, irritations', icon: '🌷' },
            { value: 'spots', label: 'Taches pigmentaires, teint inégal', icon: '☀️' },
          ],
        },
      ];

      // Branche Regard — algorithme du document « Diagnostic cils talika.com V1
      // 11-03-2021 », actualisé sur la gamme 2026.
      this.lashQuestions = [
        {
          id: 'lashWishes',
          title: 'Que souhaitez-vous pour vos cils ? (plusieurs réponses possibles)',
          type: 'checkbox',
          options: [
            { value: 'longer', label: 'Des cils plus longs', icon: '📏' },
            { value: 'fuller', label: 'Une frange de cils plus fournie', icon: '🪶' },
            { value: 'pigmented', label: 'Des cils naturellement plus pigmentés', icon: '🖤' },
            { value: 'curled', label: 'Des cils mieux recourbés', icon: '⤴️' },
            { value: 'resistant', label: 'Des cils plus résistants', icon: '💪' },
          ],
        },
        {
          id: 'lashMascara',
          title: 'Utilisez-vous du mascara quotidiennement ?',
          type: 'radio',
          options: [
            { value: 'yes', label: 'Oui, tous les jours ou presque' },
            { value: 'no', label: 'Non, rarement ou jamais' },
          ],
        },
        {
          id: 'mascaraType',
          title: 'Côté mascara, vous cherchez plutôt…',
          type: 'radio',
          condition: answers => answers.lashMascara === 'yes',
          options: [
            { value: 'volume', label: 'Du volume XXL', imageHandle: 'lipocils-mascara-xxl-volume' },
            { value: 'length', label: 'De la longueur (effet extension)', imageHandle: 'lipocils-mascara-xxl-extension' },
            { value: 'waterproof', label: 'De la tenue (résistant à l\'eau)', imageHandle: 'lipocils-mascara-xxl-extension-black-water-resistant' },
            { value: 'natural', label: 'Un résultat naturel au quotidien', imageHandle: 'lipocils-mascara-1' },
          ],
        },
        {
          id: 'lashEyeliner',
          title: 'Utilisez-vous un eyeliner ou un crayon quotidiennement ?',
          type: 'radio',
          options: [
            { value: 'yes', label: 'Oui, régulièrement' },
            { value: 'no', label: 'Non' },
          ],
        },
      ];

      // La liste des questions dépend de l'univers choisi ; les usages
      // existants de this.questions (progression, navigation) restent valides.
      Object.defineProperty(this, 'questions', {
        get() {
          if (this.answers.universe === 'lashes') {
            return [this.universeQuestion, ...this.lashQuestions.filter(q => !q.condition || q.condition(this.answers))];
          }
          if (this.answers.universe === 'skin') {
            return [this.universeQuestion, ...this.skinQuestions];
          }
          return [this.universeQuestion];
        },
      });

      this.productDatabase = {
        cleanser: { name: 'Mousse Nettoyante Hydratante Skintelligence', description: 'Mousse nettoyante hydratante pour tous types de peau' },
        eauMicellaire: { name: 'Eau Micellaire Hydratante Skintelligence', description: 'Eau micellaire démaquillante et nettoyante' },
        serumHydra: { name: 'Serum Hydra Skintelligence', description: 'Sérum ultra-hydratant à l\'acide hyaluronique' },
        serumAntiAge: { name: 'Serum Anti-Age Skintelligence', description: 'Sérum anti-âge concentré aux peptides' },
        serumPurifiant: { name: 'Serum Purifiant Skintelligence', description: 'Sérum purifiant pour peaux à imperfections' },
        glowtion: { name: 'Glowtion', description: 'Lotion éclat révélatrice de luminosité' },
        gommage: { name: 'Gommage Doux Hydratant', description: 'Gommage doux exfoliant et hydratant' },
        dayCremeLight: { name: 'Crème Légère Hydra Skintelligence', description: 'Crème hydratante légère jour' },
        dayCremeRich: { name: 'Crème Riche Hydra Skintelligence', description: 'Crème hydratante riche jour et nuit' },
        dayCremeAntiAgeDry: { name: 'Crème de Jour Régénérante Anti-Age', description: 'Crème de jour anti-âge pour peaux sèches' },
        nightCremeAntiAgeDry: { name: 'Crème de Nuit Régénérante Anti-Age', description: 'Crème de nuit anti-âge pour peaux sèches' },
        dayCremeAntiAgeOily: { name: 'Gel-Crème Anti-Age Jour', description: 'Gel-crème de jour anti-âge pour peaux grasses et mixtes' },
        nightCremeAntiAgeOily: { name: 'Gel-Crème Anti-Age Nuit', description: 'Gel-crème de nuit anti-âge pour peaux grasses et mixtes' },
        gelCremePurifiant: { name: 'Gel-Crème Purifiant', description: 'Gel-crème purifiant pour peaux mixtes à grasses' },
        maskHydrating: { name: 'Bio Enzymes Mask Hydratant', description: 'Masque biocellulose ultra-hydratant' },
        maskAntiAge: { name: 'Bio Enzymes Mask Anti-Age', description: 'Masque biocellulose anti-âge au collagène' },
        maskPurifying: { name: 'Bio Enzymes Mask Purifiant', description: 'Masque biocellulose purifiant aux acides de fruits' },
        maskBrightening: { name: 'Bio Enzymes Mask Éclaircissant', description: 'Masque biocellulose éclat anti-taches à la vitamine C' },
        maskSoothing: { name: 'Bio Enzymes Mask Cica Repair Apaisant', description: 'Masque apaisant réparateur à la Centella Asiatica' },
        freeSkin: { name: 'Free Skin Light Therapy Device', description: 'Appareil de luminothérapie anti-imperfections' },
        bubbleMask: { name: 'Bubble Mask Bio-Detox', description: 'Masque moussant détoxifiant au charbon' },
        timeControl: { name: 'Time Control 7+ Multi-Correction', description: 'Soin anti-âge ciblé multi-correction intensif' },
        lipocils: { name: 'Lipocils', description: 'Soin stimulant la pousse des cils au Complexe Végétal Mythique' },
        lipocilsExpert: { name: 'Lipocils Expert', description: 'Sérum culte : pousse, courbure et pigmentation naturelle des cils' },
        lipocilsPlatinium: { name: 'Lipocils Platinium', description: 'Duo sérums jour/nuit : des cils plus longs, plus nombreux, plus foncés' },
        lipocilsDemaquillant: { name: 'Lipocils Démaquillant', description: 'Baume démaquillant qui stimule la pousse des cils' },
        lipocilsCrayon: { name: 'Lipocils Crayon', description: 'Crayon yeux à la texture fondante qui fortifie les cils' },
        mascaraClassic: { name: 'Lipocils Mascara', description: 'Mascara soin : longueur, courbure et pousse des cils' },
        mascaraXXLVolume: { name: 'Lipocils Mascara XXL Volume', description: 'Mascara volume qui stimule la pousse des cils' },
        mascaraXXLExtension: { name: 'Lipocils Mascara XXL Extension', description: 'Mascara effet extension qui maquille et fait pousser les cils' },
        mascaraExtensionWR: { name: 'Lipocils Mascara Extension Water Resistant', description: 'Mascara extension résistant à l\'eau, au complexe pousse des cils' },
      };

      this.init();
    }

    init() {
      if (!validateProducts()) {
        this.container.innerHTML = `
          <div style="text-align: center; padding: 40px; color: #dc2626;">
            <h3>⚠️ Configuration incomplète</h3>
            <p>Certains produits sont manquants dans la collection Shopify.</p>
          </div>
        `;
        return;
      }

      this.loadProgress();
      this.render();
    }

    saveProgress() {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify({
          currentStep: this.currentStep,
          answers: this.answers,
          showResults: this.showResults,
          doneUniverses: this.doneUniverses,
          savedRoutine: this.savedRoutine,
          timestamp: Date.now(),
        }));
      } catch (error) {
        console.warn('Impossible de sauvegarder le progrès:', error);
      }
    }

    loadProgress() {
      try {
        const saved = sessionStorage.getItem(this.storageKey);
        if (!saved) return;

        const { currentStep, answers, showResults, doneUniverses, savedRoutine, timestamp } = JSON.parse(saved);
        const maxAge = 2 * 60 * 60 * 1000;
        if (Date.now() - timestamp > maxAge) {
          this.clearProgress();
          return;
        }

        this.currentStep = currentStep || 0;
        this.answers = answers || {};
        this.showResults = showResults || false;
        this.doneUniverses = doneUniverses || [];
        this.savedRoutine = savedRoutine || null;
        // Session d'une ancienne version (sans univers) : on repart proprement
        if ((this.currentStep > 0 || this.showResults) && !this.answers.universe) {
          this.currentStep = 0;
          this.answers = {};
          this.showResults = false;
          this.clearProgress();
        }
        if (this.currentStep >= this.questions.length) {
          this.currentStep = this.questions.length - 1;
        }
      } catch (error) {
        console.warn('Impossible de charger la session:', error);
        this.clearProgress();
      }
    }

    clearProgress() {
      try {
        sessionStorage.removeItem(this.storageKey);
      } catch (error) {
        console.warn('Impossible de supprimer la session:', error);
      }
    }

    generateRecommendations() {
      let routine = this.answers.universe === 'lashes'
        ? this.getLashRoutine()
        : (() => {
            const { skinType, concerns = [], age } = this.answers;
            return this.hasAgingSigns(concerns, age)
              ? this.getRoutineWithAgingSigns(skinType, concerns.includes('imperfections'), concerns)
              : this.getRoutineWithoutAgingSigns(skinType, concerns.includes('imperfections'), concerns);
          })();

      // Cross-sell : la routine de l'univers précédent est conservée et fusionnée
      if (this.savedRoutine) {
        routine = {
          morning: [...new Set([...this.savedRoutine.morning, ...routine.morning])],
          evening: [...new Set([...this.savedRoutine.evening, ...routine.evening])],
          weekly: [...new Set([...this.savedRoutine.weekly, ...routine.weekly])],
          targeted: [...new Set([...this.savedRoutine.targeted, ...routine.targeted])],
        };
      }

      return {
        morning: filterHiddenProducts(routine.morning),
        evening: filterHiddenProducts(routine.evening),
        weekly: filterHiddenProducts(routine.weekly),
        targeted: filterHiddenProducts(routine.targeted),
      };
    }

    // Règles du document 2021 : « plus fournis » → Platinium ; sinon
    // pigmentés/recourbés → Expert ; sinon Lipocils. Soin matin + soir, ou
    // soir seulement en cas de maquillage quotidien. Maquillage quotidien →
    // Lipocils Démaquillant ; sinon Eau Micellaire.
    getLashRoutine() {
      const wishes = this.answers.lashWishes || [];
      const usesMascara = this.answers.lashMascara === 'yes';
      const usesEyeliner = this.answers.lashEyeliner === 'yes';
      const wearsMakeup = usesMascara || usesEyeliner;

      const care = wishes.includes('fuller')
        ? 'lipocilsPlatinium'
        : (wishes.includes('pigmented') || wishes.includes('curled'))
          ? 'lipocilsExpert'
          : 'lipocils';

      const mascaraByType = {
        volume: 'mascaraXXLVolume',
        length: 'mascaraXXLExtension',
        waterproof: 'mascaraExtensionWR',
        natural: 'mascaraClassic',
      };

      const routine = { morning: [], evening: [], weekly: [], targeted: [] };
      if (!wearsMakeup) routine.morning.push(care);
      if (usesMascara) routine.morning.push(mascaraByType[this.answers.mascaraType] || 'mascaraClassic');
      if (usesEyeliner) routine.morning.push('lipocilsCrayon');
      routine.evening.push(care, wearsMakeup ? 'lipocilsDemaquillant' : 'eauMicellaire');
      return routine;
    }

    hasAgingSigns(concerns, age) {
      return concerns.includes('wrinkles') || age === 'over45' || age === '35-45';
    }

    getRoutineWithAgingSigns(skinType, hasImperfections, concerns) {
      const routine = { morning: [], evening: [], weekly: [], targeted: [] };
      if (['normal', 'dry'].includes(skinType)) {
        routine.morning = ['eauMicellaire', 'glowtion', 'serumAntiAge', 'dayCremeAntiAgeDry'];
        routine.evening = ['eauMicellaire', 'glowtion', 'serumAntiAge', 'nightCremeAntiAgeDry'];
        routine.weekly = ['maskAntiAge'];
      } else if (['combination', 'oily'].includes(skinType)) {
        routine.morning = ['cleanser', 'glowtion', 'serumAntiAge', ...(hasImperfections ? ['serumPurifiant', 'dayCremeAntiAgeOily'] : ['dayCremeAntiAgeOily'])];
        routine.evening = ['cleanser', 'glowtion', 'serumAntiAge', ...(hasImperfections ? ['serumPurifiant', 'nightCremeAntiAgeOily'] : ['nightCremeAntiAgeOily'])];
        routine.weekly = ['maskAntiAge', ...(hasImperfections ? ['maskPurifying'] : [])];
        if (hasImperfections) routine.targeted = ['freeSkin'];
      }
      this.addSupplementaryProducts(routine, concerns);
      return routine;
    }

    getRoutineWithoutAgingSigns(skinType, hasImperfections, concerns) {
      const routine = { morning: [], evening: [], weekly: [], targeted: [] };
      if (skinType === 'normal') {
        routine.morning = ['eauMicellaire', 'gommage', 'serumHydra', 'dayCremeLight'];
        routine.evening = ['eauMicellaire', 'serumHydra', 'dayCremeLight'];
        routine.weekly = ['maskHydrating'];
      } else if (skinType === 'dry') {
        routine.morning = ['eauMicellaire', 'gommage', 'serumHydra', 'dayCremeRich'];
        routine.evening = ['eauMicellaire', 'serumHydra', 'dayCremeRich'];
        routine.weekly = ['maskHydrating'];
      } else if (['combination', 'oily'].includes(skinType)) {
        routine.morning = ['cleanser', 'glowtion', ...(hasImperfections ? ['serumPurifiant', 'gelCremePurifiant'] : ['gelCremePurifiant'])];
        routine.evening = ['cleanser', 'glowtion', ...(hasImperfections ? ['serumPurifiant', 'gelCremePurifiant'] : ['gelCremePurifiant'])];
        routine.weekly = ['maskPurifying', ...(hasImperfections ? ['bubbleMask'] : [])];
        if (hasImperfections) routine.targeted = ['freeSkin'];
      }
      this.addSupplementaryProducts(routine, concerns);
      return routine;
    }

    addSupplementaryProducts(routine, concerns) {
      if (concerns.includes('spots')) {
        if (!routine.weekly.includes('maskBrightening')) routine.weekly.push('maskBrightening');
        if (!routine.targeted.includes('timeControl')) routine.targeted.push('timeControl');
      }
      if (concerns.includes('sensitivity')) {
        if (!routine.weekly.includes('maskSoothing')) routine.weekly.push('maskSoothing');
        routine.weekly = routine.weekly.filter(p => p !== 'bubbleMask');
      }
      if (concerns.includes('dehydration') && !routine.weekly.includes('maskHydrating')) {
        routine.weekly.push('maskHydrating');
      }
    }

    handleAnswer(questionId, value, isCheckbox) {
      // Première réponse = diagnostic démarré. Indispensable pour calculer
      // le taux de complétion (démarrages vs Diagnostic Completed).
      if (!this.startTracked) {
        this.startTracked = true;
        trackKlaviyo('Started Diagnostic', { first_question: questionId });
      }

      if (isCheckbox) {
        const current = this.answers[questionId] || [];
        this.answers[questionId] = current.includes(value)
          ? current.filter(v => v !== value)
          : [...current, value];
      } else if (questionId === 'universe') {
        // Changer d'univers invalide les réponses de l'autre branche
        this.answers = { universe: value };
      } else {
        this.answers[questionId] = value;
        if (questionId === 'lashMascara' && value === 'no') {
          delete this.answers.mascaraType;
        }
      }
      this.saveProgress();
      this.render();
    }

    nextStep() {
      if (this.currentStep < this.questions.length - 1) {
        this.currentStep++;
      } else {
        this.showResults = true;
      }
      this.saveProgress();
      this.render();
    }

    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
        this.saveProgress();
        this.render();
      }
    }

    restart() {
      this.currentStep = 0;
      this.answers = {};
      this.showResults = false;
      this.completionTracked = false;
      this.doneUniverses = [];
      this.savedRoutine = null;
      this.clearProgress();
      this.render();
      showNotification('🔄 Diagnostic redémarré', 'info');
    }

    // --- CTA maître : routine pré-cochée, total dynamique, jauge DIAG20 ---

    toggleRoutineItem(productKey) {
      if (this.routineSelection.has(productKey)) {
        this.routineSelection.delete(productKey);
      } else {
        this.routineSelection.add(productKey);
      }
      const el = document.getElementById('routine-master');
      if (el) el.innerHTML = this.buildMasterCtaInner();
    }

    addSelectedRoutine() {
      const keys = [...this.routineSelection];
      if (!keys.length) {
        showNotification('Sélectionnez au moins un produit', 'warning');
        return;
      }
      window.addRoutineToCart(keys);
    }

    // « Le matin · Le soir · 1 à 2 fois/semaine » selon la place du produit
    routineUsage(productKey) {
      const r = this.lastRecommendations || {};
      const inMorning = (r.morning || []).includes(productKey);
      const inEvening = (r.evening || []).includes(productKey);
      const parts = [];
      if (inMorning && inEvening) parts.push('Matin & soir');
      else if (inMorning) parts.push('Le matin');
      else if (inEvening) parts.push('Le soir');
      if ((r.weekly || []).includes(productKey)) parts.push('1 à 2 fois par semaine');
      if ((r.targeted || []).includes(productKey)) parts.push('Soin ciblé');
      return parts.join(' · ');
    }

    // Tag « 🎯 » uniquement si le produit répond à une préoccupation cochée
    concernTag(productKey) {
      const selected = [...(this.answers.concerns || []), ...(this.answers.lashWishes || [])];
      const match = (PRODUCT_TARGETS[productKey] || []).find(t => selected.includes(t));
      return match ? TARGET_LABELS[match] : null;
    }

    buildMasterCtaInner() {
      const selected = [...this.routineSelection];
      const totalCents = routineValueCents(selected);
      const { code, amountCents, thresholdCents } = ROUTINE_OFFER;
      const offerUnlocked = totalCents >= thresholdCents;

      const rows = this.routineUniqueKeys.map(key => {
        const shopifyProduct = getShopifyProduct(key);
        const info = this.productDatabase[key] || {};
        const checked = this.routineSelection.has(key);
        const usage = this.routineUsage(key);
        const tag = this.concernTag(key);
        const image = shopifyProduct.image
          ? `<img src="${shopifyProduct.image.startsWith('//') ? 'https:' + shopifyProduct.image : shopifyProduct.image}" alt="" loading="lazy" style="width: 48px; height: 48px; border-radius: 8px; object-fit: cover; background: #f9fafb; flex-shrink: 0; ${checked ? '' : 'opacity: 0.4; filter: grayscale(1);'}" onerror="this.style.display='none';">`
          : '';
        return `
          <label style="display: flex; align-items: center; gap: 12px; padding: 10px 12px; border-radius: 10px; cursor: pointer; background: ${checked ? '#f0f9ff' : 'transparent'};">
            <input type="checkbox" ${checked ? 'checked' : ''} onchange="window.diagnostic.toggleRoutineItem('${key}')" style="accent-color: #66a8bc; cursor: pointer; width: 18px; height: 18px; flex-shrink: 0;" />
            ${image}
            <span style="flex: 1; min-width: 0;">
              <span style="display: block; font-size: 14px; font-weight: 600; color: ${checked ? '#1f2937' : '#9ca3af'}; ${checked ? '' : 'text-decoration: line-through;'}">${info.name || shopifyProduct.name}${tag && checked ? ` <span style="font-size: 11px; font-weight: 600; color: #92400e; background: #fef3c7; padding: 1px 8px; border-radius: 999px; white-space: nowrap;">🎯 ${tag}</span>` : ''}</span>
              <span style="display: block; font-size: 12px; color: ${checked ? '#6b7280' : '#c4c8cf'}; margin-top: 2px;">${usage ? `<strong style="color: ${checked ? '#4a90a4' : '#c4c8cf'};">${usage}</strong> — ` : ''}${info.description || ''}</span>
            </span>
            <span style="font-size: 14px; font-weight: 600; color: ${checked ? '#1f2937' : '#9ca3af'}; flex-shrink: 0;">${shopifyProduct.price || ''}</span>
          </label>
        `;
      }).join('');

      // Le code lui-même n'est jamais affiché : il arrive par email (capture)
      const offerBlock = offerUnlocked
        ? `
          <div style="display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; margin: 12px 0 4px;">
            <span style="font-size: 15px; color: #9ca3af; text-decoration: line-through;">${formatEuros(totalCents)}</span>
            <span style="font-size: 24px; font-weight: 700; color: #1f2937;">${formatEuros(totalCents - amountCents)}</span>
            <span style="font-size: 13px; font-weight: 600; color: #065f46; background: #d1fae5; padding: 2px 10px; border-radius: 999px;">🎁 −20 € débloqués</span>
          </div>
        `
        : `
          <div style="margin: 12px 0 4px;">
            <span style="font-size: 24px; font-weight: 700; color: #1f2937;">${formatEuros(totalCents)}</span>
          </div>
          <div style="margin: 0 0 12px;">
            <div style="width: 100%; background: #e5e7eb; border-radius: 999px; height: 6px; overflow: hidden;">
              <div style="height: 100%; background: linear-gradient(90deg, #66a8bc, #4a90a4); width: ${Math.min(100, Math.round((totalCents / thresholdCents) * 100))}%;"></div>
            </div>
            <p style="font-size: 13px; color: #6b7280; margin: 6px 0 0;">Plus que <strong>${formatEuros(thresholdCents - totalCents)}</strong> pour débloquer <strong>−20 €</strong> sur votre routine</p>
          </div>
        `;

      return `
        <h2 style="font-size: 18px; font-weight: 600; color: #1f2937; margin: 0 0 12px;">Votre routine en un clic</h2>
        <div style="display: flex; flex-direction: column; gap: 2px; margin-bottom: 4px;">${rows}</div>
        ${offerBlock}
        <button onclick="window.diagnostic.addSelectedRoutine()" style="width: 100%; background: linear-gradient(135deg, #66a8bc, #4a90a4); color: white; border: none; padding: 14px 24px; border-radius: 12px; font-size: 16px; font-weight: 600; cursor: pointer; box-shadow: 0 4px 12px rgba(102, 168, 188, 0.3);" onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">🛒 Ajouter ma routine (${selected.length} produit${selected.length > 1 ? 's' : ''})</button>
      `;
    }

    // Le form Klaviyo peut légitimement ne pas s'afficher (déjà soumis,
    // profil identifié — ciblage voulu : DIAG20 réservé aux nouveaux contacts).
    // Dans ce cas on retire le bloc promesse plutôt que de promettre à vide.
    scheduleCaptureCheck() {
      let attempts = 0;
      const timer = setInterval(() => {
        attempts++;
        const wrap = document.getElementById('diagnostic-capture');
        if (!wrap) { clearInterval(timer); return; }
        const embed = wrap.querySelector('.klaviyo-form-Re9bCe');
        if (embed && embed.children && embed.children.length > 0) { clearInterval(timer); return; }
        if (attempts >= 6) { clearInterval(timer); wrap.style.display = 'none'; }
      }, 1000);
    }

    // Cross-sell : enchaîne sur les questions de l'autre univers en gardant
    // la routine déjà construite (fusion à l'écran résultats)
    startCrossSell(universe) {
      this.savedRoutine = this.lastRecommendations;
      this.doneUniverses.push(this.answers.universe);
      this.answers = { universe };
      this.currentStep = 1;
      this.showResults = false;
      this.completionTracked = false;
      this.saveProgress();
      this.render();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }

    buildCrossSellBlock() {
      const done = [...this.doneUniverses, this.answers.universe];
      const next = ['skin', 'lashes'].find(u => !done.includes(u));
      if (!next) return '';
      const teaser = next === 'lashes'
        ? { icon: '👁️', title: 'Et votre regard ?', text: 'Des cils plus longs, plus fournis ? Complétez votre routine en 3 questions.', cta: 'Continuer avec le diagnostic Regard →' }
        : { icon: '✨', title: 'Et votre peau ?', text: 'Une routine visage sur mesure en 3 questions, ajoutée à votre sélection.', cta: 'Continuer avec le diagnostic Peau →' };
      return `
        <div style="padding: 20px; background: linear-gradient(135deg, #fef3c7, #fef9e7); border: 1px solid #f59e0b; border-radius: 12px; margin: 20px 0 0; display: flex; align-items: center; gap: 16px; flex-wrap: wrap;">
          <div style="flex: 1; min-width: 220px;">
            <h3 style="font-weight: 600; color: #92400e; margin: 0 0 4px; font-size: 16px;">${teaser.icon} ${teaser.title}</h3>
            <p style="font-size: 13px; color: #92400e; margin: 0;">${teaser.text}</p>
          </div>
          <button onclick="window.diagnostic.startCrossSell('${next}')" style="background: linear-gradient(135deg, #f59e0b, #d97706); color: white; border: none; padding: 12px 20px; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; white-space: nowrap;" onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">${teaser.cta}</button>
        </div>
      `;
    }

    // Section de routine repliable — l'écran résultats reste court, le détail
    // est à un clic (seul le matin est ouvert par défaut)
    buildRoutineSection(icon, title, productKeys, openByDefault) {
      if (!productKeys.length) return '';
      return `
        <details ${openByDefault ? 'open' : ''} style="background: white; border: 1px solid #e5e7eb; border-radius: 12px; margin-bottom: 12px; overflow: hidden;">
          <summary style="padding: 14px 18px; cursor: pointer; font-size: 16px; font-weight: 600; color: #1f2937; display: flex; align-items: center; gap: 8px; list-style: none;">
            <span style="font-size: 20px;">${icon}</span> ${title}
            <span style="font-weight: 400; color: #9ca3af; font-size: 14px;">· ${productKeys.length} produit${productKeys.length > 1 ? 's' : ''}</span>
            <span style="margin-left: auto; color: #66a8bc; font-size: 13px; font-weight: 500;">voir le détail</span>
          </summary>
          <div style="padding: 4px 18px 16px; display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 12px;">
            ${productKeys.map((productKey, index) => this.createProductCard(productKey, title, index)).join('')}
          </div>
        </details>
      `;
    }

    createProductCard(productKey, section, index) {
      const productInfo = this.productDatabase[productKey];
      const shopifyProduct = getShopifyProduct(productKey);
      if (!shopifyProduct) {
        return `<div class="product-error">❌ Produit ${productKey} non disponible<br><small>Handle: ${productMapping[productKey] || 'inconnu'}</small></div>`;
      }

      const imageDisplay = shopifyProduct.image && (shopifyProduct.image.startsWith('http') || shopifyProduct.image.startsWith('//'))
        ? `<img src="${shopifyProduct.image.startsWith('//') ? 'https:' + shopifyProduct.image : shopifyProduct.image}" alt="${shopifyProduct.name}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;" onerror="this.style.display='none';">`
        : `<div style="display: flex; align-items: center; justify-content: center; font-size: 24px; color: #66a8bc;">📦</div>`;

      return `
        <div class="product-card" style="background: linear-gradient(to bottom right, white, #f0f9ff); border: 2px solid #66a8bc; border-radius: 12px; padding: 16px; margin-bottom: 16px; box-shadow: 0 4px 8px rgba(102,168,188,0.1);">
          <div style="display: flex; gap: 12px; margin-bottom: 12px;">
            <div style="width: 64px; height: 64px; background: #66a8bc; color: white; border-radius: 8px; overflow: hidden;">${imageDisplay}</div>
            <div style="flex: 1;">
              <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                <h4 style="font-weight: 600; color: #1f2937; font-size: 14px; margin: 0;">${shopifyProduct.name}</h4>
                <span style="color: #66a8bc; font-weight: bold; font-size: 14px;">${shopifyProduct.price}</span>
              </div>
              <p style="color: #6b7280; font-size: 12px; margin: 4px 0;">${productInfo.description}</p>
              ${!shopifyProduct.available ? '<p style="color: #dc2626; font-size: 11px; font-weight: 500;">⚠️ Temporairement indisponible</p>' : ''}
            </div>
          </div>
          <div style="display: flex; gap: 8px;">
            <button onclick="handleSingleProductAdd('${productKey}')" style="background: ${shopifyProduct.available ? '#66a8bc' : '#9ca3af'}; color: white; border: none; padding: 8px 12px; border-radius: 8px; font-size: 12px; font-weight: 500; cursor: ${shopifyProduct.available ? 'pointer' : 'not-allowed'}; flex: 1; transition: opacity 0.2s;" ${!shopifyProduct.available ? 'disabled' : ''} onmouseover="if(${shopifyProduct.available}) this.style.opacity='0.9'" onmouseout="if(${shopifyProduct.available}) this.style.opacity='1'">${shopifyProduct.available ? '🛒 Ajouter au panier' : '😔 Épuisé'}</button>
            <a href="${shopifyProduct.url}" target="_blank" style="background: #f3f4f6; color: #374151; padding: 8px 12px; border-radius: 8px; font-size: 12px; text-decoration: none; border: 1px solid #d1d5db;">👁️ Voir</a>
          </div>
        </div>
      `;
    }

    render() {
      this.showResults ? this.renderResults() : this.renderQuestion();
    }

    renderResults() {
      if (!this.container) {
        console.error('❌ Container diagnostic-root not found');
        return;
      }

      try {
        const recommendations = this.generateRecommendations();
        this.saveProgress();
        this.lastRecommendations = recommendations;

        // Routine pré-cochée du CTA maître (produits uniques, disponibles)
        this.routineUniqueKeys = [...new Set([
          ...recommendations.morning,
          ...recommendations.evening,
          ...recommendations.weekly,
          ...recommendations.targeted,
        ])].filter(key => getShopifyProduct(key));
        this.routineSelection = new Set(this.routineUniqueKeys);

        // ✅ Sauvegarder directement dans Shopify
        console.log('📝 Sauvegarde du diagnostic dans Shopify...');
        saveDiagnosticToShopifyCustomer(this.answers, recommendations);

        // render() est rappelé à chaque ajout au panier : on ne remonte
        // l'événement qu'une fois par diagnostic terminé.
        if (!this.completionTracked) {
          this.completionTracked = true;
          const now = new Date();
          trackKlaviyo('Diagnostic Completed', {
            universe: [...(this.doneUniverses || []), this.answers.universe || 'skin'].join('+'),
            lash_wishes: this.answers.lashWishes || [],
            age_range: this.answers.age || '',
            skin_type: this.answers.skinType || '',
            concerns: this.answers.concerns || [],
            morning_routine: recommendations.morning,
            evening_routine: recommendations.evening,
            weekly_care: recommendations.weekly,
            targeted_care: recommendations.targeted,
            routine_counts: {
              morning: recommendations.morning.length,
              evening: recommendations.evening.length,
              weekly: recommendations.weekly.length,
              targeted: recommendations.targeted.length,
            },
            routine_value: routineValue([...new Set([
              ...recommendations.morning,
              ...recommendations.evening,
              ...recommendations.weekly,
              ...recommendations.targeted,
            ])]),
            diagnostic_date: now.toISOString(),
            $event_id: String(Math.floor(now.getTime() / 1000)),
          });

          const productNames = keys => keys.map(k => (this.productDatabase[k] || {}).name).filter(Boolean);
          const profileProps = {
            diagnostic_universe: [...(this.doneUniverses || []), this.answers.universe || 'skin'].join('+'),
            diagnostic_date: now.toISOString(),
            diagnostic_routine_value: routineValue([...new Set([
              ...recommendations.morning,
              ...recommendations.evening,
              ...recommendations.weekly,
              ...recommendations.targeted,
            ])]),
            diagnostic_morning_routine: productNames(recommendations.morning),
            diagnostic_evening_routine: productNames(recommendations.evening),
            diagnostic_weekly_routine: productNames(recommendations.weekly),
            diagnostic_targeted_routine: productNames(recommendations.targeted),
          };
          if (this.answers.skinType) profileProps.diagnostic_skin_type = this.answers.skinType;
          if (this.answers.age) profileProps.diagnostic_age_range = this.answers.age;
          if ((this.answers.concerns || []).length) profileProps.diagnostic_concerns = this.answers.concerns;
          if ((this.answers.lashWishes || []).length) profileProps.diagnostic_lash_wishes = this.answers.lashWishes;
          identifyKlaviyo(profileProps);
        }

        this.scheduleCaptureCheck();
        this.container.innerHTML = `
        <div style="max-width: 1200px; margin: 0 auto; padding: 24px; background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe); min-height: 100vh;">
          <div style="background: white; border-radius: 16px; box-shadow: 0 8px 16px rgba(0,0,0,0.1); padding: 32px; border: 1px solid #e5e7eb;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; flex-wrap: wrap; gap: 16px;">
              <h1 style="font-size: clamp(18px, 4vw, 32px); font-weight: bold; color: #1f2937; margin: 0;">Votre Routine Personnalisée</h1>
              <button onclick="window.diagnostic.restart()" style="color: #66a8bc; background: none; border: none; cursor: pointer; font-size: 14px; font-weight: 500; padding: 8px 16px; border-radius: 6px;" onmouseover="this.style.background='#f0f9ff'" onmouseout="this.style.background='none'">🔄 Refaire le diagnostic</button>
            </div>
            <div id="routine-master" style="background: linear-gradient(to bottom right, white, #f0f9ff); border: 2px solid #66a8bc; border-radius: 16px; padding: 24px; margin-bottom: 16px; box-shadow: 0 8px 16px rgba(102,168,188,0.15);">${this.buildMasterCtaInner()}</div>
            <div id="diagnostic-capture" style="padding: 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-radius: 12px; border: 1px solid #10b981; margin-bottom: 24px;">
              <h3 style="font-weight: 600; color: #065f46; margin-bottom: 8px; display: flex; align-items: center; gap: 8px; font-size: 17px;"><span style="font-size: 22px;">🎁</span> Recevez votre code −20 € par email</h3>
              <div class="klaviyo-form-Re9bCe" style="margin: 8px 0;"></div>
              <p style="font-size: 12px; color: #6b7280; margin: 4px 0 0 0;">🔒 Vos données restent chez Talika • 💬 Envoi par WhatsApp possible en option</p>
            </div>
            ${this.buildRoutineSection('🌅', 'Routine Matin', recommendations.morning, true)}
            ${this.buildRoutineSection('🌙', 'Routine Soir', recommendations.evening, false)}
            ${this.buildRoutineSection('📅', 'Soins Hebdomadaires', recommendations.weekly, false)}
            ${this.buildRoutineSection('🎯', 'Soins Ciblés', recommendations.targeted, false)}
            ${this.buildCrossSellBlock()}
            <p style="text-align: center; margin: 20px 0 0; font-size: 13px; color: #9ca3af;">Diagnostic créé par l'expertise Talika — Beauté française depuis 1948</p>
          </div>
        </div>
      `;

      } catch (error) {
        console.error('❌ Erreur renderResults:', error);
      }
    }

    renderQuestion() {
      if (!this.container) {
        console.error('❌ Container diagnostic-root not found');
        return;
      }

      try {
        const question = this.questions[this.currentStep];
        // Tant que l'univers n'est pas choisi, la longueur du parcours est
        // inconnue : on affiche le pire cas et jamais « dernière étape ».
        const totalSteps = this.answers.universe ? this.questions.length : 4;
        const isLastStep = !!this.answers.universe && this.currentStep === this.questions.length - 1;
        const canProceed = this.answers[question.id] && (question.type !== 'checkbox' || this.answers[question.id].length > 0);

        this.container.innerHTML = `
        <div style="max-width: 600px; margin: 0 auto; padding: 24px; background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe); min-height: 100vh;">
          <div style="background: white; border-radius: 16px; box-shadow: 0 8px 16px rgba(0,0,0,0.1); padding: 32px; border: 1px solid #e5e7eb;">
            <div style="margin-bottom: 24px; text-align: center;">
              <h1 style="font-size: clamp(20px, 4vw, 24px); font-weight: bold; color: #1f2937; margin-bottom: 8px; display: flex; align-items: center; justify-content: center; gap: 12px;">
                <img src="data:image/svg+xml,%3Csvg viewBox='0 0 100 40' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50' y='25' text-anchor='middle' font-family='Arial, sans-serif' font-size='16' font-weight='bold' fill='%2366a8bc'%3ETALIKA%3C/text%3E%3C/svg%3E" alt="Talika" style="height: 24px;">
                Diagnostic Talika
              </h1>
              <p style="font-size: 14px; color: #6b7280; margin: 0;">Votre routine personnalisée en quelques questions</p>
            </div>
            <div style="margin-bottom: 24px;">
              <div style="width: 100%; background: #e5e7eb; border-radius: 12px; height: 8px; overflow: hidden;">
                <div style="height: 100%; background: linear-gradient(90deg, #66a8bc, #4a90a4); border-radius: 12px; transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1); width: ${((this.currentStep + 1) / totalSteps) * 100}%;">
                  <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3)); animation: shimmer 2s infinite;"></div>
                </div>
              </div>
              <p style="font-size: 13px; color: #6b7280; margin: 8px 0 0; text-align: center;">Étape ${this.currentStep + 1} sur ${totalSteps}</p>
            </div>
            <h2 style="font-size: clamp(16px, 3vw, 18px); font-weight: 600; color: #1f2937; margin-bottom: 24px; text-align: center;">${question.title}</h2>
            <div style="display: flex; flex-direction: column; gap: 12px;">
              ${question.options.map(option => {
                const isSelected = question.type === 'checkbox'
                  ? (this.answers[question.id] || []).includes(option.value)
                  : this.answers[question.id] === option.value;
                // Visuel du choix : packshot produit si dispo, sinon picto, sinon rien
                const optionImage = option.imageUrl || (option.imageHandle && products[option.imageHandle] && products[option.imageHandle].featured_image);
                const optionVisual = optionImage
                  ? `<img src="${optionImage.startsWith('//') ? 'https:' + optionImage : optionImage}" alt="" loading="lazy" style="width: 64px; height: 64px; border-radius: 10px; object-fit: cover; background: #f9fafb; flex-shrink: 0; margin-right: 12px;" onerror="this.style.display='none';">`
                  : option.icon
                    ? `<span aria-hidden="true" style="width: 40px; height: 40px; display: inline-flex; align-items: center; justify-content: center; font-size: 20px; background: ${isSelected ? '#e6f3f5' : '#f3f4f6'}; border-radius: 10px; flex-shrink: 0; margin-right: 12px;">${option.icon}</span>`
                    : '';
                return `
                  <label style="display: flex; align-items: center; padding: 16px; border: 2px solid ${isSelected ? '#66a8bc' : '#e5e7eb'}; border-radius: 12px; cursor: pointer; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); background: ${isSelected ? 'linear-gradient(135deg, #f0f9ff, #e6f3f5)' : 'white'};" onmouseover="if(!${isSelected}) { this.style.borderColor='#66a8bc'; this.style.background='#f9fafb'; this.style.transform='scale(1.01)'; }" onmouseout="if(!${isSelected}) { this.style.borderColor='#e5e7eb'; this.style.background='white'; this.style.transform='scale(1)'; }">
                    <input type="${question.type === 'checkbox' ? 'checkbox' : 'radio'}" name="${question.id}" value="${option.value}" ${isSelected ? 'checked' : ''} onchange="window.diagnostic.handleAnswer('${question.id}', '${option.value}', ${question.type === 'checkbox'})" style="margin-right: 12px; accent-color: #66a8bc; cursor: pointer;" />
                    ${optionVisual}
                    <span style="color: #374151; font-size: 14px;">${option.label}</span>
                  </label>
                `;
              }).join('')}
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 32px;">
              <button onclick="window.diagnostic.prevStep()" ${this.currentStep === 0 ? 'disabled' : ''} style="padding: 12px 10px; color: ${this.currentStep === 0 ? '#9ca3af' : '#6b7280'}; background: none; border: none; cursor: ${this.currentStep === 0 ? 'not-allowed' : 'pointer'}; font-weight: 500; border-radius: 8px;" ${this.currentStep > 0 ? 'onmouseover="this.style.color=\'#374151\'; this.style.background=\'#f3f4f6\';" onmouseout="this.style.color=\'#6b7280\'; this.style.background=\'none\';"' : ''}>← Précédent</button>
              <button onclick="window.diagnostic.nextStep()" ${!canProceed ? 'disabled' : ''} style="padding: 12px; background: ${canProceed ? 'linear-gradient(135deg, #66a8bc, #4a90a4)' : '#d1d5db'}; color: white; border: none; border-radius: 12px; cursor: ${canProceed ? 'pointer' : 'not-allowed'}; font-weight: 600; box-shadow: ${canProceed ? '0 4px 12px rgba(102, 168, 188, 0.3)' : 'none'}; font-size: 14px;" ${canProceed ? 'onmouseover="this.style.transform=\'scale(1.05)\'; this.style.boxShadow=\'0 6px 16px rgba(102, 168, 188, 0.4)\';" onmouseout="this.style.transform=\'scale(1)\'; this.style.boxShadow=\'0 4px 12px rgba(102, 168, 188, 0.3)\';"' : ''}>${isLastStep ? 'Voir mes recommandations' : 'Suivant →'}</button>
            </div>
          </div>
        </div>
        <style>
          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
          .diagnostic-notification {
            position: fixed;
            bottom: 20px;
            right: 20px;
            background: #fff;
            border-radius: 8px;
            padding: 12px 20px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.3s, transform 0.3s;
            z-index: 1000;
          }
          .diagnostic-notification.show {
            opacity: 1;
            transform: translateY(0);
          }
          .diagnostic-notification.info { border-left: 4px solid #3b82f6; }
          .diagnostic-notification.success { border-left: 4px solid #10b981; }
          .diagnostic-notification.warning { border-left: 4px solid #f59e0b; }
          .diagnostic-notification.error { border-left: 4px solid #dc2626; }
        </style>
      `;
      } catch (error) {
        console.error('❌ Erreur renderQuestion:', error);
      }
    }
  }

  // Initialisation
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('talika-diagnostic-root');
    if (container) {
      window.diagnostic = new DiagnosticApp('talika-diagnostic-root');
      Object.assign(window, { 
        addToCartShopify, 
        addRoutineToCart, 
        addCompleteRoutine, 
        handleSingleProductAdd, 
        showNotification, 
        updateCartCount 
      });
      console.log('✅ Diagnostic Talika prêt !');
    } else {
      console.error('❌ Container talika-diagnostic-root non trouvé');
    }
  });
})();